import { agencyDetailed } from '@app/models';
import { gql } from 'apollo-angular';

export const reloadAgencies = 'agencyReload';
export const reloadAgenciesQuery = gql`
  query agencyReload {
    agencyReload {
      ...agencyDetailed
    }
  }
  ${agencyDetailed}
`;
